import Location from "domain/Location";

export const initState = {
    list: [],
    current: null,
    isLoading: false,
    hasFailed: false,
    pagination: {
        total: 0,
        page: 1,
        pageSize: 20,
        hasMore: false
    }
};

export default function locationReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_LOCATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LIST_LOCATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LIST_LOCATION_FULFILLED': {
            if (payload && payload.data && payload.pagination) {
                return {
                    ...state,
                    list: payload.data.map(item => new Location(item)),
                    pagination: payload.pagination,
                    isLoading: false,
                    hasFailed: false
                };
            } else {
                return {
                    ...state,
                    list: payload.map(item => new Location(item)),
                    pagination: { ...initState.pagination },
                    isLoading: false,
                    hasFailed: false
                };
            }
        }
        
        case 'LOAD_MORE_LOCATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LOAD_MORE_LOCATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LOAD_MORE_LOCATION_FULFILLED': {
            return {
                ...state,
                list: [...state.list, ...payload.data.map(item => new Location(item))],
                pagination: payload.pagination,
                isLoading: false,
                hasFailed: false
            };
        }

        case 'GET_LOCATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'GET_LOCATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'GET_LOCATION_FULFILLED': {
            return {
                ...state,
                current: new Location(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'SAVE_LOCATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'SAVE_LOCATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'SAVE_LOCATION_FULFILLED': {
            return {
                ...state,
                current: new Location(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'UPDATE_LOCATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'UPDATE_LOCATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'UPDATE_LOCATION_FULFILLED': {
            return {
                ...state,
                current: new Location(payload),
                list: state.list.map(location => 
                    location.id === payload.id ? new Location(payload) : location
                ),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'DELETE_LOCATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'DELETE_LOCATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'DELETE_LOCATION_FULFILLED': {
            return {
                ...state,
                list: state.list.filter(location => location.id !== payload.id),
                current: state.current?.id === payload.id ? null : state.current,
                isLoading: false,
                hasFailed: false
            };
        }

        case 'CLEAR_LOCATION': {
            return { ...initState };
        }

        case 'SET_CURRENT_LOCATION': {
            return {
                ...state,
                current: payload ? new Location(payload) : null
            };
        }

        default: {
            return state;
        }
    }
}